/**
 * A mapping between height tokens and their respective font size tokens. This ensures harmonious
 * typography scaling within interface components.
 */ const heightToFontSize = {
    '2xs': 'xs',
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl',
    '2xl': 'xl'
};

export { heightToFontSize };
//# sourceMappingURL=height-to-font-size.js.map
